import { useState } from "react";
import { useOrderFlow } from "../../../OrderFlow/OrderFlowProvider/OrderFlowContext";
import { getSortOption, sortingFunction } from "./sortingUtils";
/**
 * @param sequenceNumber Sequence number of module, used to get it's configuration.
 * @param itemsToSort Array of items to sort, default = [].
 * @param enableCustomerSorting Boolean, default = false.
 * @param isSortSelectorDisabled Boolean, default = false.
 * @param enableCostSorting Boolean, default = true.
 * @param enableSuggestedSorting Boolean, default = false.
 * @param defaultToSuggested Boolean, default = false.
 * @note Pass undefined to any value to use the default.
 * @note_example const sortingReturn = useSorting(itemsToSort, undefined, undefined, undefined, undefined, undefined)
 * @returns See UseSortingReturn.
 */
export const useSorting = (sequenceNumber, itemsToSort = [], enableCustomerSorting = false, isSortSelectorDisabled = false, enableCostSorting = true, enableSuggestedSorting = false, defaultToSuggested = false) => {
    var _a;
    const { store, dispatch } = useOrderFlow();
    const defaultOption = getSortOption(enableSuggestedSorting, enableCostSorting, store.cart.recipeSortOption, store.cart.productSortOption, defaultToSuggested, sequenceNumber);
    const [sortMethod, setSortMethod] = useState(defaultOption);
    const curriedSortingFunction = sortingFunction(sortMethod);
    return {
        sortingFunction: curriedSortingFunction,
        sortingFunctionComparableString: curriedSortingFunction.toString(),
        sortedItems: (_a = itemsToSort === null || itemsToSort === void 0 ? void 0 : itemsToSort.sort(sortingFunction(sortMethod))) !== null && _a !== void 0 ? _a : [],
        sortSelectorProps: {
            enableCustomerSorting,
            sortMethod,
            setSortMethod,
            isSortSelectorDisabled,
            enableCostSorting,
            dispatch,
            enableSuggestedSorting,
        },
    };
};
